import React from "react";
import PropTypes from "prop-types";

import DateInput from "./DateInput";
import InlineCalendar from "./InlineCalendar";

// CSSのインポート（共通のために一箇所だけで行う）
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/themes/light.css";
import "./flatpickr_soremo.css";

/**
 * カレンダーコンポーネント
 * インラインモードの場合はInlineCalendar、それ以外はDateInputを表示
 */
const Calendar = (props) => {
  const { inline, ...restProps } = props;
  
  if (inline) {
    return <InlineCalendar {...restProps} />;
  }
  
  return <DateInput {...restProps} />;
};

Calendar.propTypes = {
  /** ラベルテキスト */
  label: PropTypes.string,
  
  /** "必須"や"任意"などのオプション表示 */
  option: PropTypes.string,
  
  /** プレースホルダーテキスト */
  placeholder: PropTypes.string,
  
  /** コンポーネントの幅 (例: "100%", "240px") */
  width: PropTypes.string,
  
  /** 選択モード ("single", "range", "multiple") */
  mode: PropTypes.oneOf(["single", "range", "multiple"]),
  
  /** インライン表示するかどうか */
  inline: PropTypes.bool,
  
  /** 選択された日付または日付範囲 */
  value: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string,
    PropTypes.array
  ]),
  
  /** 日付が変更されたときのコールバック */
  onChange: PropTypes.func,
  
  /** 選択可能な最大日付 */
  maxDate: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string
  ]),
  
  /** 選択可能な最小日付 */
  minDate: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string
  ]),
  
  /** フォーム要素の名前 */
  name: PropTypes.string,
  
  /** 追加のクラス名 */
  className: PropTypes.string,
  
  /** 日付フォーマット */
  dateFormat: PropTypes.string,
  
  /** 入力を許可するかどうか */
  allowInput: PropTypes.bool,
  
  /** 必須入力かどうか（バリデーション用） */
  required: PropTypes.bool,
  
  /** 年の選択範囲 [minYear, maxYear] */
  yearRange: PropTypes.arrayOf(PropTypes.number),
  
  /** flatpickrに渡す追加オプション */
  options: PropTypes.object
};

Calendar.defaultProps = {
  width: "100%",
  mode: "single",
  inline: false,
  allowInput: false,
  required: false
};

export default React.memo(Calendar, (prevProps, nextProps) => {
  return (
    prevProps.value === nextProps.value &&
    prevProps.minDate === nextProps.minDate &&
    prevProps.maxDate === nextProps.maxDate &&
    prevProps.mode === nextProps.mode &&
    prevProps.inline === nextProps.inline
  );
}); 